import LocationLayout from './LocationLayout';
import { P, H2b, UL, LI } from '../content/Typography';
import { locations } from './locations';

const meta = locations.find((l) => l.slug === 'metal-fabrication-kitchener-waterloo');

export default function KitchenerWaterloo() {
  return (
    <LocationLayout title={meta.title} description={meta.description} heading={meta.heading}>
      <H2b>An automotive and machinery heritage</H2b>
      <P>
        Kitchener-Waterloo's manufacturing base grew up alongside Ontario's automotive and machinery industries, and that legacy still defines much of the
        region's fabrication capacity. Generations of shops here were built to supply precision components into the automotive supply chain, which left
        the region with a deep bench of fabricators comfortable with production-grade tolerances, repeatable processes, and the documentation that
        automotive clients expect.
      </P>

      <H2b>Where manufacturing meets the tech ecosystem</H2b>
      <P>
        More recently, that manufacturing base has started overlapping with a very different industry: the tech startup ecosystem centered around the
        University of Waterloo. Hardware startups and product teams in the region increasingly rely on the same fabrication shops that have historically
        served automotive clients — sourcing custom enclosures, mounting hardware, and structural prototypes for products that never existed a generation
        ago, but need the same machining precision automotive parts always required.
      </P>

      <H2b>Cambridge's welding sector</H2b>
      <P>
        Cambridge, immediately south of Kitchener, has its own distinct fabrication identity built around heavier welding work. The city's shops handle
        structural steel, welded assemblies, and larger-format fabrication — a useful complement to Kitchener-Waterloo's precision machining strength when
        a project needs both.
      </P>

      <H2b>Tool-and-die expertise</H2b>
      <P>
        The region's automotive roots also left it with a concentration of tool-and-die shops — fabricators skilled in precision mold-making and the kind
        of exacting, repeatable machining that tooling work demands. That same skill set translates directly into high-precision custom parts for clients
        well outside the automotive industry.
      </P>

      <UL>
        <LI><strong>Automotive suppliers</strong> — production-grade components built to supply-chain tolerances and documentation standards.</LI>
        <LI><strong>Hardware startups and product teams</strong> — enclosures, mounting hardware, and structural prototypes for new products.</LI>
        <LI><strong>Industrial and machinery manufacturers</strong> — precision machined and welded components for equipment built in the region.</LI>
      </UL>
      <P>
        That combination is part of what makes the region unusual: a hardware startup a few blocks from the university can often get a precision prototype
        machined by a shop with decades of automotive tooling experience, at a level of accuracy that is hard to find paired with that kind of fast,
        low-volume turnaround anywhere else in Ontario.
      </P>
      <P>
        Submit a sketch of your project and MetalMatch will match you with a Kitchener-Waterloo or Cambridge fabricator suited to it — whether that means a
        tool-and-die shop for a precision component or a Cambridge welding shop for a structural assembly.
      </P>
    </LocationLayout>
  );
}
